import { render, staticRenderFns } from "./InvoicesDataTable.vue?vue&type=template&id=4ff2fad0&"
import script from "./InvoicesDataTable.vue?vue&type=script&lang=js&"
export * from "./InvoicesDataTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesDataTable.vue?vue&type=style&index=0&id=4ff2fad0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports